<!--
  template(if) - list(show) 구조는 불필요한 로드를 방지하기 위해서임.
  refresh 는 add, edit 성공시 호출해야 함.
-->

<template>
  <div class="animated fadeIn">
    <template v-if="base">
      <b-card :class="''">
        <span class="text-center" v-b-tooltip.hover title="can see the log real-time">
          Real-time refresh interval
          <select v-model="sync.interval" @change="refresh">
            <option disabled value="15">Please select interval : Default 15</option>
            <option value=10>10</option>
            <option value=30>30</option>
            <option value=60>60</option>
            <option value=300>300(5 min)</option>
          </select>
          sec
        </span>
        <span class="float-right">
          <i :class="`fa fa-refresh ${sync.th && !sync.stop ? 'fa-spin' : ''}`"></i>
          <b-btn @click="pause" size="sm" variant="warning">Pause</b-btn>
        </span>

      </b-card>
      <ListWSFinderResult v-show="list_wsfinder_result" ref="list_wsfinder_result" :is_main="true" :limit="20"/>
      <ListWMDSResult v-show="lsit_wmds_result" ref="list_wmds_result" :is_main="true" :limit="20"/>
    </template>
  </div>
</template>

<script>
import ListWMDSResult from './WMDS.Result';
import ListWSFinderResult from './WSFinder.Result';

export default {
  components: { ListWMDSResult, ListWSFinderResult },
  data: () => ({ base: true, list_wsfinder_result : false, lsit_wmds_result : false, sync : { th : undefined, interval : 15, stop : false } }),
  methods: {
    refresh() {
      if(this.sync.th) { this.sync.th = undefined; }
      if(!this.sync.stop && this.$refs.list_wsfinder_result) { this.$refs.list_wsfinder_result.refresh(); }
      if(!this.sync.stop && this.$refs.list_wmds_result) { this.$refs.list_wmds_result.refresh(); }
      this.sync.th = setTimeout(this.refresh, 1000 * this.sync.interval );
      console.log("integrity", 'status', this.sync.stop ? 'stop' : 'refresh');
      // interval 30 sec
    },
    select({ id, tag }) {
      this.list_wsfinder_result = this.lsit_wmds_result = true;
      if(!this.sync.th) { this.refresh() }
    },
    SyncClear() {
      if(this.sync.th) { clearTimeout(this.sync.th); this.sync.th = undefined; console.debug("integtiry", "sync", "clear") }
    },
    pause: function() { this.sync.stop = !this.sync.stop; this.refresh(); },
  },
  watch: {
    '$route' (to, from) {
      console.log('integrity.vue', 'route changed', to.param);
      this.select(to.params);
    }
  },
  created() { console.log('integrity.vue', 'created'); },
  destroyed() { console.log('integrity.vue', 'destroyed'); this.SyncClear() },
  mounted() { console.log('integrity.vue', 'mounted'); this.select(this.$route.params); },
}
</script>
